import {Button, Card, ListGroup} from "react-bootstrap";
import {useCallback, useEffect, useState} from "react";
import useCallBackend from "../../hooks/use-call-backend";
import Error from "../../common/error";
// @ts-ignore
import classes from "./request-list.module.css";
import Loading from "../../common/loading";

interface RequestListResponse {
    id: number,
    dealerName: string
}

const RequestList:React.FC<{handleRequestSelection:(selectedId: number)=>void}> = (props) => {
    const {isLoading, error, invokeBackend} = useCallBackend();
    const [requestList, setRequestList] = useState<RequestListResponse[]>([]);

    const getListHandler = useCallback(() => {
        const handleResponse = (responseData:[RequestListResponse]) => {
            setRequestList(responseData);
        };

        invokeBackend({url: "/api/vapActivation/pendingRequest"}, handleResponse);
    }, [invokeBackend]);

    useEffect(() => {
        getListHandler();
    }, [getListHandler]);

    let content = <Loading />;

    if(!isLoading) {
        if(error){
            content = <Error message={error} />;
        } else {

            content = (
                <Card>
                    <Card.Header className="my-auto"><strong>Requests:</strong>
                        <Button variant="secondary" type="button" className="float-end" onClick={getListHandler}>Refresh</Button>
                    </Card.Header>
                    <ListGroup variant="flush" className={classes.scroll}>
                        {requestList.map(requestItem => <ListGroup.Item action key={requestItem.id} onClick={() => {props.handleRequestSelection(requestItem.id)}}>{requestItem.dealerName}</ListGroup.Item>)}
                    </ListGroup>
                </Card>
            );
        }
    }

    return (content);
}

export  default RequestList;

